"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _Button = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Button");

var _Button2 = _interopRequireDefault(_Button);

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _fonts = require("@quixeltools/quixel-ui-library/dist/utils/fonts");

var _components = require("components");

var _glamor = require("glamor");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _utils = require("../../EpicMigration/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var accountDropdown = (0, _glamor.css)({
  color: _css.pallets.grayMidLight_dropDowns
});

var group = (0, _glamor.css)({
  padding: (0, _css.unitRem)(1) + " " + (0, _css.unitRem)(1)
});

var borderBottom = (0, _glamor.css)({
  borderBottom: "2px solid " + _css.pallets.darkGray_background,
  ":last-child": {
    borderBottom: "none"
  }
});

var additionalGroup = (0, _glamor.css)({
  paddingTop: "1rem",
  paddingBottom: "1rem"
});

var highLight = (0, _glamor.css)({
  paddingTop: "0.6rem",
  paddingBottom: "0.6rem",
  "&:hover": {
    opacity: "1",
    background: _css.pallets.lightGray_hightlight,
    "& a": {
      color: "white"
    }
  }
});

var icon = function icon(img) {
  return (0, _glamor.css)((0, _css.bgContain)(img), {
    width: "28px",
    height: "auto"
  });
};

var usernameGroup = (0, _glamor.css)({
  fontWeight: 400,

  padding: "" + (0, _css.unitRem)(0.75)
});
var points = (0, _glamor.css)(_fonts.H6, {
  color: _css.pallets.white,
  textTransform: "uppercase"
});
var link = (0, _glamor.css)({
  display: "block",

  width: "100%",
  textAlign: "left",
  lineHeight: "2px",
  marginLeft: "0.6rem",

  padding: (0, _css.unitRem)(0.3) + " " + (0, _css.unitRem)(0.125),
  ":first-child": {
    paddingTop: (0, _css.unitRem)(0.3)
  },

  ":last-child": {
    paddingBottom: (0, _css.unitRem)(0.3)
  },
  "& a": {
    textUnderlinePosition: "under",
    textTransform: "uppercase",
    fontWeight: 700,
    letterSpacing: "0.75px"
  }
});

var pointsGroup = (0, _glamor.css)({
  textAlign: "center",
  display: "flex",
  justifyContent: "space-around",
  flexDirection: "column"
});
var refill = (0, _glamor.css)({
  display: "flex",
  marginTop: (0, _css.unitRem)(0.5),
  flexDirection: "column",
  justifyContent: "space-between",
  "& span button": {
    paddingLeft: "1.85rem",
    paddingRight: "1.85rem"
  }
});

var subscribeButton = (0, _glamor.css)({
  "& span a": {
    width: "100%"
  }
});

var alignItem = (0, _glamor.css)({
  display: "flex",
  justifyContent: "space-between",
  marginBottom: (0, _css.unitRem)(0.7),
  ":last-child": {
    marginBottom: 0
  }
});

var AccountDropdown = function AccountDropdown(props) {
  var showPoints = props.planId && (0, _utils.shouldShowPoints)(props.planId);
  var addPointsAllowed = props.isActive && props.doesGetCharged === true && (0, _utils.isAddPointsAllowed)(props.planId);
  var showRefillInXDays = props.refillIn > 0 && props.doesGetCharged === true && (0, _utils.shouldShowRefillInXDays)(props.planId);

  return _react2.default.createElement(
    "div",
    accountDropdown,
    !props.isActive && _react2.default.createElement(
      "div",
      {
        className: (0, _glamor.css)(group, borderBottom, {
          textAlign: "center",
          border: "none",
          paddingBottom: 0
        }) },
      _react2.default.createElement(_Button2.default, {
        small: true,
        mode: "secondary",
        label: "SUBSCRIBE",
        to: props.onSubscribeClick,
        className: subscribeButton
      })
    ),
    _react2.default.createElement(
      "div",
      (0, _extends3.default)({ className: (0, _glamor.css)(group, borderBottom) }, usernameGroup),
      _react2.default.createElement(
        "span",
        {
          className: (0, _glamor.css)(_fonts.p5, {
            paddingLeft: "" + (0, _css.unitRem)(0.25),
            color: _css.pallets.gray_text,
            textTransform: "uppercase"
          }) },
        props.username
      )
    ),
    props.planName,
    showPoints && _react2.default.createElement(
      "div",
      (0, _glamor.css)(group, borderBottom, pointsGroup),
      _react2.default.createElement(
        "span",
        null,
        _react2.default.createElement(
          "span",
          { className: points },
          " ",
          props.points
        ),
        _react2.default.createElement(
          "span",
          { className: points },
          " P"
        )
      ),
      !props.hasMonetizationStopped && (showRefillInXDays || addPointsAllowed) && _react2.default.createElement(
        "span",
        refill,
        showRefillInXDays && _react2.default.createElement(
          "span",
          {
            className: (0, _glamor.css)({
              color: "#808080",
              marginBottom: addPointsAllowed ? (0, _css.unitRem)(1) : 0,
              letterSpacing: -0.4
            }) },
          "Points will refill in: ",
          props.refillIn,
          " days"
        ),
        addPointsAllowed && _react2.default.createElement(_Button2.default, {
          small: true,
          className: (0, _glamor.css)({
            "& button": {
              width: "100%",
              letterSpacing: "0.75px",
              fontWeight: "700"
            }
          }),
          mode: "primary",
          label: "ADD MEGASCANS POINTS",
          onClick: props.onAddPointsClick
        })
      )
    ),
    _react2.default.createElement(
      "div",
      { className: (0, _glamor.css)(additionalGroup, borderBottom) },
      _react2.default.createElement(
        "div",
        { className: (0, _glamor.css)(group, highLight) },
        _react2.default.createElement(
          "div",
          { className: alignItem },
          _react2.default.createElement("span", {
            className: icon("https://d3uwib8iif8w1p.cloudfront.net/megascans/icons/account.svg")
          }),
          _react2.default.createElement(_components.TextButtonLibrary, {
            className: link,
            mode: "small-normal",
            label: "Account",
            to: props.external ? "" : props.accountTo,
            onClick: props.external ? props.onAccountsClick : undefined
          })
        )
      ),
      _react2.default.createElement(
        "div",
        { className: (0, _glamor.css)(group, highLight) },
        _react2.default.createElement(
          "div",
          { className: alignItem },
          _react2.default.createElement("span", {
            className: icon("https://d3uwib8iif8w1p.cloudfront.net/quixel/icons/bridge_icon_2048.png")
          }),
          _react2.default.createElement(_components.TextButtonLibrary, {
            className: link,
            mode: "small-normal",
            label: "Download Bridge",
            to: props.external ? "" : props.onDownloadBridgeClick,
            onClick: props.external ? props.onDownloadBridgeClick : undefined
          })
        )
      ),
      _react2.default.createElement(
        "div",
        { className: (0, _glamor.css)(group, highLight) },
        _react2.default.createElement(
          "div",
          { className: alignItem },
          _react2.default.createElement("span", {
            className: icon("https://d3uwib8iif8w1p.cloudfront.net/quixel/icons/mixer_icon_2048_preview.png")
          }),
          _react2.default.createElement(_components.TextButtonLibrary, {
            className: link,
            mode: "small-normal",
            label: "Download Mixer",
            to: props.external ? "" : props.onDownloadMixerClick,
            onClick: props.external ? props.onDownloadMixerClick : undefined
          })
        )
      )
    ),
    props.onSettingsClick && _react2.default.createElement(
      "div",
      { className: alignItem },
      _react2.default.createElement(_components.TextButtonLibrary, {
        className: link,
        mode: "small-normal",
        label: "Settings",
        onClick: props.onSettingsClick
      })
    ),
    _react2.default.createElement(
      "div",
      { className: (0, _glamor.css)(group, highLight, additionalGroup) },
      _react2.default.createElement(
        "div",
        { className: alignItem },
        _react2.default.createElement("span", {
          className: icon("https://d3uwib8iif8w1p.cloudfront.net/quixel/icons/sign_out.svg")
        }),
        _react2.default.createElement(_components.TextButtonLibrary, {
          className: (0, _glamor.css)({ "& a": { textDecoration: "none" } }, link),
          mode: "small-normal",
          label: "Sign Out",
          onClick: props.onSignoutClick,
          to: "/"
        })
      )
    )
  );
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    hasMonetizationStopped: state.eol.hasMonetizationStopped
  };
})(AccountDropdown);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AccountDropdown/AccountDropdown.jsx
// module id = 2577
// module chunks = 0